import removeObjKeys from '@glass/common/modules/utils/removeObjKeys';

const cleanTypename = (obj: Record<string, unknown>, keys: string[] = []) =>
  obj && removeObjKeys(obj, ['__typename', ...keys]);

export default cleanTypename;
